import { getFirestore, getCloudStorage, getCloudFunctions } from '../../system/firebase';

import { mapDefinedFields } from '../dtoHelper';
// import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { SNACK_BAR_MESSAGE_OPERATION_FAILED, SNACK_BAR_MESSAGE_SAVE, UPLOADED_VIDEO_STATUS_APPROVED } from '../constants';

import { format as formatDate, getTime } from 'date-fns';
// import format from 'date-fns/format';
import addMinutes from 'date-fns/addMinutes';
import getMinutes from 'date-fns/getMinutes';
import set from 'date-fns/set';

import _map from 'lodash/map';
import _omit from 'lodash/omit';

export const saveAdCusData = async ({ data, callBack, setCustomerData }) => {
    try {
        const functions = getCloudFunctions();
        const saveAdCustomer = functions.httpsCallable('saveAdCustomer');
        const result = await saveAdCustomer(mapDefinedFields(data));

        setCustomerData && setCustomerData({ ...data, adCusId: result?.data?.adCusId });
        callBack && callBack();
        return;
    } catch (error) {
        console.log('Error in Saving Customer', error?.message);
        alert(error?.message);
    }
};

export const uploadAdPicture = async ({ file, adCusId, setSnackbarErrorMessage, setProgress, callBack, setSnackbarMessage }) => {
    const db = getFirestore();
    const storage = getCloudStorage();
    const now = new Date();

    // const name = _get(file, 'name');
    const flagDto = { isAd: 'Y' };
    const timestampStr = formatDate(new Date(), 'yyyyMMddHHmmss_T');
    const storagePath = `/ad/${adCusId}/temp/images/${timestampStr}`;
    const uploadTask = storage.ref(storagePath).put(file, { customMetadata: { adCusId, key: timestampStr, originFilename: timestampStr, ...flagDto } });

    const uploadedImagesRef = db.collection('uploadedImages').doc();

    uploadTask.on(
        'state_changed',
        snapshot => {
            // progress function ...
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress && setProgress(progress);
        },
        error => {
            // Error function ...
            console.error('File upload failed', error);
        },
        async () => {
            // complete function ...
            try {
                const url = await storage.ref(storagePath).getDownloadURL();

                //------------------------------------------------------------------------------------
                // creating Uploaded Image Doc
                //------------------------------------------------------------------------------------
                const uploadedImageDto = {
                    createDt: now,
                    status: UPLOADED_VIDEO_STATUS_APPROVED, // P, F, A, C, D
                    updateDt: now,
                    url,
                    isAd: true,
                };

                await uploadedImagesRef.set(mapDefinedFields(uploadedImageDto));
                setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
                callBack && callBack(url);
            } catch (error) {
                setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
                console.error('Failed to obtain file URL:', error);
            }
        },
    );
};

export const checkAvailability = async ({ startDt, setSnackbarErrorMessage, jobCtr, talentCtr, empSearch, setLoading }) => {
    try {
        const dto = mapDefinedFields({ startDtMs: getTime(startDt), jobCtr, talentCtr, empSearch });

        const functions = getCloudFunctions();
        const checkAdAvailability = functions.httpsCallable('checkAdAvailability');
        const result = await checkAdAvailability(dto);

        if (result?.data?.status === 'success') {
            setLoading(false);
            console.log(result?.data?.result);
            return result?.data?.result;
        }
    } catch (error) {
        console.log(error.message);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        setLoading(false);
    }
};

export const makePlacementsOnHold = async ({ advertisements, setSnackbarErrorMessage, callBack, setLoading, callBackIfPlacementsNotAvailable }) => {
    try {
        const functions = getCloudFunctions();

        // check availability for all selected placements
        let availabilityResultList = [];
        const checkAdAvailability = functions.httpsCallable('checkAdAvailability');
        await Promise.all(
            _map(advertisements, async adItem => {
                const dto = mapDefinedFields({ startDtMs: getTime(adItem.startDt), jobCtr: adItem.jobCtr, talentCtr: adItem.talentCtr, empSearch: adItem.empSearch });
                const availabilityResult = await checkAdAvailability(dto);
                if (availabilityResult?.data?.status === 'success')
                    availabilityResultList = [...availabilityResultList, ...(availabilityResult?.data ? availabilityResult.data.result : [])];
            }),
        );

        // checking if the query result have selected placement
        let placementsAvailable = true;

        // eslint-disable-next-line no-unused-expressions
        advertisements?.forEach(_ad => {
            const placementTaken = availabilityResultList?.find(list => list?.pos === _ad?.pos);
            if (placementTaken) placementsAvailable = false;
        });

        // if all selected placements are available, put them on hold
        if (placementsAvailable) {
            // convert date object to milliseconds for callable function
            const mappedAdvertisements = _map(advertisements, adItem => {
                return _omit({ ...adItem, startDtMs: getTime(adItem.startDt), endDtMs: getTime(adItem.endDt) }, ['startDt', 'endDt']);
            });

            // make placements on hold
            const makeAdPlacementsOnHold = functions.httpsCallable('makeAdPlacementsOnHold');
            const result = await makeAdPlacementsOnHold({ advertisements: mappedAdvertisements });

            if (result?.data?.status === 'success') {
                callBack && callBack(result?.data?.docsId);
            } else if (result?.data?.status === 'error') {
                setLoading(false);
                //TODO What do we do if makeAdPlacementsOnHold failed???
            }
        }
        // at least one of the selected placements are not available, call special callback
        else {
            callBackIfPlacementsNotAvailable && callBackIfPlacementsNotAvailable(availabilityResultList);
        }
    } catch (error) {
        console.log(error.message);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        setLoading(false);
    }
};

export const releaseAllPlacementOnHold = async ({ onHoldDocIds, setSnackbarErrorMessage }) => {
    try {
        const functions = getCloudFunctions();
        const releaseAdPlacementOnHold = functions.httpsCallable('releaseAdPlacementOnHold');
        const result = await releaseAdPlacementOnHold(mapDefinedFields({ onHoldDocIds }));

        if (result?.data?.status === 'success') {
            return 'success';
        } else {
            console.log('Failed to release placement on hold.');
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
            return null;
        }
    } catch (error) {
        console.log(error.message);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return null;
    }
};

export const purchaseAds = async ({ onHoldDocIds, setSnackbarMessage, setSnackbarErrorMessage, callBack, setLoading }) => {
    try {
        const functions = getCloudFunctions();
        const purchaseAdPlacements = functions.httpsCallable('purchaseAdPlacements');
        const result = await purchaseAdPlacements(mapDefinedFields({ onHoldDocIds }));

        if (result?.data?.status === 'success') {
            setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
            callBack && callBack();
        }
    } catch (error) {
        console.log(error.message);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        setLoading(false);
    }
};

export const loadAdvertisementsByPage = async ({ jobCtr, talentCtr, empSearch, callBack }) => {
    const db = getFirestore();
    const now = new Date();
    let startDt;

    const nowMinutes = getMinutes(now);

    // if less or equal  than 30 minutes
    if (nowMinutes <= 30) {
        startDt = set(now, { minutes: 0, seconds: 0, milliseconds: 0 });
    }
    // if greater than 30 minutes
    if (nowMinutes > 30) {
        startDt = set(now, { minutes: 30, seconds: 0, milliseconds: 0 });
    }
    const endDt = addMinutes(startDt, 30);

    console.log('>>>>>>>>>>>>> AD-QUERY STARTED>>>>>>>>>>>>>>>>>');

    let arr = [{}, {}, {}, {}];

    try {
        //TODO: Change the Collection Name on Both Web and Cloud functions
        let availableAdsQuery;

        if (jobCtr) availableAdsQuery = db.collection('ad2').where('jobCtr', '==', true).where('startDt', '>=', startDt).where('startDt', '<', endDt).limit(4);
        if (talentCtr) availableAdsQuery = db.collection('ad2').where('talentCtr', '==', true).where('startDt', '>=', startDt).where('startDt', '<', endDt).limit(4);
        if (empSearch) availableAdsQuery = db.collection('ad2').where('empSearch', '==', true).where('startDt', '>=', startDt).where('startDt', '<', endDt).limit(4);

        // run the Query
        const querySnapShot = await availableAdsQuery.get();
        if (querySnapShot.empty) {
            console.log('Empty Query');
            arr = [];
        } else {
            querySnapShot.forEach(doc => {
                const data = doc.data();
                arr[data?.pos - 1] = doc.data();
            });
        }
        // console.log(arr);
        console.log('>>>>>>>>>>>>> AD-QUERY FINSIHED>>>>>>>>>>>>>>>>>');
        callBack && callBack(arr);
    } catch (error) {
        console.log('Erorr in fetching Ad', error.message);
    }
};
